<template>
  <md-dialog
    :md-active.sync="active"
    :md-close-on-esc="false"
    :md-click-outside-to-close="false"
  >
    <md-dialog-title
      >{{ i18n.lbl_sub() }} - {{ values.Description }}</md-dialog-title
    >
    <input-field2
      :label="i18n.lbl_client()"
      :sec-label="i18n.lbl_new_client()"
      v-model.trim="form.client"
      :list="clients"
    />
    <input-field2
      :label="i18n.lbl_direction()"
      :sec-label="i18n.lbl_new_dir()"
      v-model.trim="form.desc"
      :list="descriptions"
    />
    <md-dialog-actions>
      <md-button
        class="md-button btn md-primary md-theme-default"
        :disabled="isLoading"
        @click="$emit('close')"
        >{{ i18n.lbl_cancel() }}</md-button
      >
      <md-button
        class="md-button btn md-primary md-theme-default"
        :disabled="sendDisabled"
        @click="send"
        >{{ i18n.lbl_send() }}</md-button
      >
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
/* eslint-disable */
import { i18n } from "@js/i18n";
import InputField2 from "@com/fields/InputField2";
import InputField from "@com/fields/InputField";
export default {
  name: "ChangeSubwalletModal",
  components: { InputField2, InputField },
  emits: ["close", "changeWalletData"],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      required: true
    },
    descriptions: {
      type: Array,
      required: true
    },
    clients: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      i18n,
      isLoading: false,
      form: {
        desc: "",
        client: ""
      },
    };
  },
  mounted() {
    this.form.desc = this.values.Description;
    this.form.client = this.values.ClientName;
  },
  computed: {
    sendDisabled () {
      return !this.form.desc || !this.form.client || this.isLoading
    }
  },
  methods: {
    async send () {
      this.isLoading = true
      await this.$emit('changeWalletData', {walletId: this.values.WalletId, client: this.form.client, desc: this.form.desc})
      this.isLoading = false
    }
  }
};
</script>

<style scoped lang="scss">
.md-title {
  padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/vue/app/dashboard/index/ChangeSubwalletModal.vue